export type SensoryEventType =
  | 'SCAN_SUCCESS'
  | 'SCAN_ERROR'
  | 'RAID_COMPLETE'
  | 'MUTATION_TRIGGERED'
  | 'MUTATION_SUCCESS'
  | 'MUTATION_ERROR'
  | 'GHOST_ECHO_NAVIGATION'

export type SensoryEventPayload = {
  source?: string
  targetId?: string | null
  message?: string
  timestamp?: number
  [key: string]: unknown
}

export type SensoryEvent = {
  type: SensoryEventType
  payload: SensoryEventPayload
  signal?: AbortSignal
}

type SensoryListener = (event: SensoryEvent) => void

const listeners = new Set<SensoryListener>()

export const subscribeSensoryEvents = (listener: SensoryListener): (() => void) => {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

export const emitSensoryEvent = (
  type: SensoryEventType,
  payload: SensoryEventPayload = {},
  options: { signal?: AbortSignal } = {},
): void => {
  if (options.signal?.aborted) return
  const event: SensoryEvent = {
    type,
    payload: {
      ...payload,
      timestamp: payload.timestamp ?? Date.now(),
    },
    signal: options.signal,
  }
  for (const listener of listeners) listener(event)
}

export const createSensoryAbortController = (): AbortController =>
  typeof AbortController !== 'undefined'
    ? new AbortController()
    : ({
        signal: { aborted: false, addEventListener: () => {}, removeEventListener: () => {} },
        abort: () => {},
      } as unknown as AbortController)
